export const SUPPORT_US_URL = "https://www.buymeacoffee.com/illumex";
